import i18n, { DEFAULT_LANG } from "../i18n";

const TRANSLATED_ROUTE = "/external_control";

const isTranslatedRoute = (pathname) => pathname.startsWith(TRANSLATED_ROUTE);

const getPathname = () => {
  if (typeof window === "undefined") return "";
  return window.location.pathname;
};

export const t = (key, options = {}) => {
  const pathname = getPathname();

  if (options.force) return i18n.t(key);

  if (isTranslatedRoute(pathname)) return i18n.t(key);

  return i18n.t(key, { lng: DEFAULT_LANG });
};